import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule } from '@purespectrum1/ui/modal';
import { ButtonModule } from '@purespectrum1/ui/button';
import { SelectDropdownModule } from '@purespectrum1/ui/select-dropdown';
import { MultiBuyerModalComponent } from './multi-buyer-modal.component';

@NgModule({
  declarations: [MultiBuyerModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule,
    ButtonModule,
    SelectDropdownModule,
  ],
  exports: [MultiBuyerModalComponent],
})
export class MultiBuyerModalModule {}
